<div role="alert" class="toast-message" [class.toast-message--is-active]="showMessage">
    <div class="toast-message__container" [ngClass]="messageContainerClass">
        <span class="toast-message__icon fas" [ngClass]="messageIcon"></span>
        <span class="toast-message__content">{{message?.message}}</span>
    </div>
</div>
